export type ClassSelector = 'background' | 'text' | 'border';
